// TaskTitleSection.jsx: the title typography block inside a TaskItemBase.
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { useTasksContext } from '@/features/tasks/context/TasksContext.def';
import {
  isMainTask,
} from '@/features/tasks/components/atoms/taskMetadataViewState';
import {
  FONT_WEIGHT_SEMIBOLD,
  FONT_WEIGHT_REGULAR,
} from '@/components/ui/taskVisualTokens';
import { useT } from '@/i18n/useT';

const renderBacklogIcon = (status) => {
  if (status !== 'Backlog') return null;
  return (
    <PauseCircleOutlineIcon
      sx={{
        fontSize: '16px',
        marginRight: '4px',
        verticalAlign: 'text-bottom',
        color: 'var(--color-grey-400)',
      }}
    />
  );
};

const renderMainTaskIcon = (isMain, mainTaskLabel) => {
  if (!isMain) return null;
  return (
    <FlagOutlinedIcon
      data-testid="task-title-main-icon"
      titleAccess={mainTaskLabel}
      sx={{
        fontSize: '16px',
        marginRight: '4px',
        verticalAlign: 'text-bottom',
        color: 'text.secondary',
      }}
    />
  );
};

/**
 * The title typography block inside a TaskItemBase.
 * Date, duration and focus-timer are shown via the shared metadata slot,
 * not inline here (see TaskMetadata / TaskExecutionActions).
 */
const TaskTitleSection = ({ task }) => {
  const { tasksMap } = useTasksContext();
  const t = useT();
  const isMain = isMainTask(task, tasksMap);
  const mainTaskLabel = t('taskitem.mainTask', 'Main task');

  return (
    <span
      className="task-item__title"
      title={task.title}
      style={{ fontWeight: isMain ? FONT_WEIGHT_SEMIBOLD : FONT_WEIGHT_REGULAR }}
    >
      {renderBacklogIcon(task.status)}
      {renderMainTaskIcon(isMain, mainTaskLabel)}
      {task.title}
    </span>
  );
};

export default TaskTitleSection;
